export const BackgroundVideoWatermark = ({ hero = false }) => (
  <div
    data-testid="background-video-watermark"
    className={`background-video-watermark absolute right-6 md:right-10 z-20 pointer-events-none select-none text-right text-white/[0.55] ${
      hero ? "top-24 md:top-28" : "top-6 md:top-10"
    }`}
    aria-label="Genuine footages. No AI, no stocks."
  >
    <span className="block text-[10px] md:text-[11px] leading-[1.35] font-medium tracking-[0.18em]">
      GENUINE FOOTAGES
    </span>
    <span className="block mt-1 text-[9px] md:text-[10px] leading-[1.35] font-medium tracking-[0.16em]">
      NO AI, NO STOCKS
    </span>
  </div>
);
